<div class="min-h-screen flex">
    <!-- Lewa strona - Formularz -->
    <div class="w-full lg:w-1/2 flex flex-col justify-center px-6 py-12 lg:px-16 xl:px-24 bg-white dark:bg-gray-900">
        <div class="max-w-md w-full mx-auto">
            <!-- Logo -->
            <div class="mb-8">
                <a routerLink="/" class="group inline-flex items-center gap-2.5">
                    <img class="h-8 w-8 rounded-lg object-contain transition-transform group-hover:scale-105" src="assets/images/logo-a.png" alt="Logo Fakturnia" width="32" height="32">
                    <span class="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Fakturnia</span>
                </a>
            </div>

            <!-- Nagłówek -->
            <div class="mb-8">
                <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                    Witaj ponownie! 👋
                </h1>
                <p class="text-gray-600 dark:text-gray-400">
                    Zaloguj się na swoje konto i kontynuuj pracę
                </p>
            </div>

            <!-- Formularz logowania -->
            <login></login>

            <!-- Linki pomocnicze -->
            <div class="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <a routerLink="/przypomnij-haslo" 
                   class="text-sm text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 font-medium transition-colors">
                    Zapomniałeś hasła?
                </a>
            </div>

            <!-- Separator -->
            <div class="relative my-8">
                <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-200 dark:border-gray-700"></div>
                </div>
                <div class="relative flex justify-center text-sm">
                    <span class="px-4 bg-white dark:bg-gray-900 text-gray-500">lub kontynuuj z</span>
                </div>
            </div>

            <!-- Logowanie przez Google -->
            <log-in-with-google class="block w-full"></log-in-with-google>

            <!-- Logowanie przez Apple -->
            <log-in-with-apple class="block w-full mt-3"></log-in-with-apple>

            <!-- Separator -->
            <div class="relative my-8">
                <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-200 dark:border-gray-700"></div>
                </div>
                <div class="relative flex justify-center text-sm">
                    <span class="px-4 bg-white dark:bg-gray-900 text-gray-500">Nie masz jeszcze konta?</span>
                </div>
            </div>

            <!-- Przycisk rejestracji -->
            <a routerLink="/rejestracja" 
               class="w-full flex items-center justify-center gap-2 px-6 py-3 border-2 border-gray-200 dark:border-gray-700 rounded-xl font-semibold text-gray-700 dark:text-gray-300 hover:border-primary-500 hover:text-primary-600 dark:hover:text-primary-400 transition-all duration-200 group">
                <span>Utwórz darmowe konto</span>
                <mat-icon [svgIcon]="'tabler_outline:arrow-right'" class="!w-5 !h-5 transition-transform group-hover:translate-x-1"></mat-icon>
            </a>
        </div>
    </div>

    <!-- Prawa strona - Graficzna sekcja -->
    <div class="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <!-- Zdjęcie w tle -->
        <img src="assets/images/auth-hero.jpg"
             alt=""
             class="absolute inset-0 w-full h-full object-cover object-center">

        <!-- Gradient overlay -->
        <div class="absolute inset-0 bg-gradient-to-br from-primary-900/80 via-primary-800/70 to-purple-900/80"></div>

        <!-- Dekoracyjne elementy -->
        <div class="absolute inset-0 pointer-events-none">
            <div class="absolute top-0 left-0 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
            <div class="absolute bottom-0 right-0 w-80 h-80 bg-purple-500/10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl"></div>
        </div>

        <!-- Treść -->
        <div class="relative z-10 flex flex-col justify-between py-12 px-12 xl:px-20 text-white h-full">
            <div></div>

            <div class="max-w-lg">
                <h2 class="text-4xl xl:text-5xl font-bold mb-6 leading-tight">
                    Fakturowanie<br>
                    <span class="text-primary-200">prostsze niż kiedykolwiek</span>
                </h2>

                <p class="text-lg text-white/80 mb-10">
                    Dołącz do kilkunastu tysięcy przedsiębiorców, którzy oszczędzają czas dzięki automatyzacji fakturowania.
                </p>

                <!-- Pobierz aplikację -->
                <div>
                    <p class="text-sm text-white/60 mb-4 font-medium uppercase tracking-wider">Pobierz aplikację</p>
                    <div class="flex items-center gap-4">
                        <a href="https://play.google.com/store/apps/details?id=io.fakturnia.mobile" target="_blank" rel="noopener" class="transition-transform hover:scale-105">
                            <img src="assets/images/googleplay.png" alt="Google Play" class="h-14 w-auto rounded-lg">
                        </a>
                        <a href="https://apps.apple.com/pl/app/fakturnia-pl-wystaw-faktury/id6746215170" target="_blank" rel="noopener" class="transition-transform hover:scale-105">
                            <img src="assets/images/applestore.png" alt="App Store" class="h-14 w-auto rounded-lg">
                        </a>
                    </div>
                </div>
            </div>

            <!-- Trust signals na dole -->
            <div class="flex items-center gap-6">
                <div class="flex items-center gap-2 text-sm text-white/60">
                    <mat-icon [svgIcon]="'tabler_outline:shield-check'" class="!w-4 !h-4 text-green-400/80"></mat-icon>
                    <span>Bezpieczne dane</span>
                </div>
                <div class="flex items-center gap-2 text-sm text-white/60">
                    <mat-icon [svgIcon]="'tabler_outline:certificate'" class="!w-4 !h-4 text-green-400/80"></mat-icon>
                    <span>Zgodne z KSeF</span>
                </div>
            </div>
        </div>
    </div>
</div>
